import { call, take, put, spawn } from 'redux-saga/effects'

import { LOCATION_CHANGE } from '../browser-location'

import * as actions from './actions'

function* clearPendingSaga(names) {
    yield take(LOCATION_CHANGE)
    yield put(actions.clearPending(names))
}

export function* indicateProgress(options, method, ...args) {
    let names

    if (typeof options === 'string') names = [options]
    else if (options instanceof Array) names = options
    else {
        names = options.names

        if (options.clearPending) yield spawn(clearPendingSaga, names)
    }

    try {
        yield put(actions.processStarted(...names))
        const result = yield call(method, ...args)
        yield put(actions.processCompleted(...names))

        return result
    } catch (exception) {
        yield put(actions.processFailed(exception, ...names))

        if (options.stopException) {
            return
        }

        throw exception
    }
}
